import { render, staticRenderFns } from "./Vip_Center.vue?vue&type=template&id=3f457cd3&scoped=true"
import script from "./Vip_Center.vue?vue&type=script&lang=js"
export * from "./Vip_Center.vue?vue&type=script&lang=js"
import style0 from "./Vip_Center.vue?vue&type=style&index=0&id=3f457cd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f457cd3",
  null
  
)

export default component.exports